import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Phone = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M21 28H11C7.14 28 4 24.86 4 21V19C4 17.346 5.346 16 7 16H11C12.654 16 14 17.346 14 19V20H18V19C18 17.346 19.346 16 21 16H25C26.654 16 28 17.346 28 19V21C28 24.86 24.86 28 21 28ZM7 18C6.449 18 6 18.449 6 19V21C6 23.757 8.243 26 11 26H21C23.757 26 26 23.757 26 21V19C26 18.449 25.551 18 25 18H21C20.449 18 20 18.449 20 19V21C20 21.552 19.552 22 19 22H13C12.448 22 12 21.552 12 21V19C12 18.449 11.551 18 11 18H7Z" />
		<path d="M21.708 12.294C21.708 12.294 19.5 10 16 10C12.5 10 10.293 12.293 10.292 12.294C10.111 12.475 10 12.725 10 13C10 13.552 10.448 14 11 14C11.274 14 11.522 13.89 11.702 13.712C11.703 13.711 13.5 12 16 12C18.5 12 20.293 13.707 20.293 13.707C20.474 13.888 20.724 14 21 14C21.552 14 22 13.552 22 13C22 12.724 21.888 12.475 21.708 12.294Z" />
		<path d="M25.805 8.409C25.803 8.406 22.5 4 16 4C9.5 4 6.197 8.406 6.195 8.409C6.073 8.575 6 8.779 6 9C6 9.552 6.448 10 7 10C7.323 10 7.609 9.847 7.792 9.609C7.794 9.607 10.5 6 16 6C21.5 6 24.203 9.602 24.204 9.604C24.387 9.844 24.675 10 25 10C25.552 10 26 9.552 26 9C26 8.778 25.927 8.574 25.805 8.409Z" />
	</svg>
);

export default Phone;
